// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes bounce-bf274918{0%,to{transform:translateY(0)}50%{transform:translateY(-5px)}}.bounce-dot[data-v-bf274918]{display:inline-block;animation:bounce-bf274918 .6s infinite;margin-right:8px;font-size:24px}@media(max-width:600px){.bounce-dot[data-v-bf274918]{font-size:16px}}", ""]);
// Exports
module.exports = exports;
